import React, { useContext, useEffect, useState } from 'react';
import $ from 'jquery';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  format,
  isValid,
  isBefore,
  intervalToDuration,
  getDate,
  getMonth,
  getYear,
  parseISO
} from 'date-fns';
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  TablePagination,
  TextField
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Controller, useForm } from 'react-hook-form';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptBRLocale from 'date-fns/locale/pt-BR';
import { IoMdEye } from 'react-icons/io';
import { toast } from 'react-toastify';
import Toast from '../../../../components/Toast';
import { options } from '../../../../helpers/toastOptions';
import { useAuth } from '../../../../hooks/Auth';
import { useIntegration } from '../../../../hooks/Integration';
import { useManager } from '../../../../hooks/Manager';
import { useModal } from '../../../../hooks/Modal';
import { usePickup } from '../../../../hooks/Pickup';
import { parseCpfCnpj, parsePhone } from '../../../../helpers/parseValues';
import { ReverseCollectContext } from '../..';
import { ModalTitle } from './styled';

export const ModalSearchKnowledge = () => {
  const [documentList, setDocumentList] = useState([]);
  const [disabledCleanButton, setDisabledCleanButton] = useState(true);
  const [disabledConfirmButton, setDisabledConfirmButton] = useState(true);

  const { user } = useAuth();
  const {
    searchUser,
    searchKnowledge,
    getBranchDetails,
    verifyUserRestriction
  } = useIntegration();
  const {
    getPickupManagerParameterization,
    getPickupManagerBranchValidations
  } = useManager();
  const { closeModal, Modal, openModal } = useModal();
  const { cancelReversePickup } = usePickup();

  const maxSM = useMediaQuery('(max-width:768px)');
  const maxMD = useMediaQuery('(max-width:900px)');

  const {
    dateSearchFrom,
    setDateSearchFrom,
    dateSearchTo,
    setDateSearchTo,
    knowledgeSearchNumber,
    setKnowledgeSearchNumber,
    knowledgeSearchId,
    setKnowledgeSearchId,
    invoiceSearchNumber,
    setInvoiceSearchNumber,
    ufSearchFrom,
    setUfSearchFrom,
    ufSearchTo,
    setUfSearchTo,
    modalSearch,
    setModalSearch,
    documentSearchSender,
    setDocumentSearchSender,
    documentSearchRecipient,
    setDocumentSearchRecipient,
    setSelectedKnowledgeIdToShowInvoices,
    setSelectedKnowledgeNumberToShowInvoices,
    lastSearchPayload,
    setLastSearchPayload,
    isSubmittingSearchPagination,
    setIsSubmittingSearchPagination,
    searchTotalPages,
    setSearchTotalPages,
    searchRows,
    setSearchRows,
    searchPage,
    setSearchPage,
    transportTypeList,
    setTransportTypeList,
    statesList,
    setKnowledgeNumber,
    knowledgeId,
    setKnowledgeId,
    setCollectSenderData,
    addressSenderList,
    setAddressSenderList,
    collectRequesterData,
    setSelectedAddressSenderIndex,
    setCollectRecipientData,
    collectLoadData,
    setCollectLoadData,
    setDisableSenderStreetAddress,
    setDisableSenderSuburb,
    setHasCreatePickupWithInvoice,
    setDisabledSenderData,
    setIsToValidateSenderDocument,
    openShowInvoiceSearchListModal,
    setProtocolCollectCanceled
  } = useContext(ReverseCollectContext);

  const searchKnowledgeNumberSchema = Yup.object().shape({});

  const {
    handleSubmit: handleSearchSubmit,
    control: searchControl,
    reset: searchReset,
    setValue: setSearchValue,
    setError: setSearchError,
    clearErrors: clearSearchErrors,
    formState: { errors: searchErrors, isSubmitting: isSubmittingSearch }
  } = useForm({
    resolver: yupResolver(searchKnowledgeNumberSchema),
    mode: 'onBlur',
    reValidateMode: 'onChange'
  });

  const onSearchSubmit = async (data) => {
    if (!data.knowledgeId || data.knowledgeId === '') {
      if (!data.searchKnowledgeFrom || data.searchKnowledgeFrom === '') {
        toast(
          <Toast
            title="Atenção!"
            content="O campo “Data – Período de” deve ser preenchido para prosseguir com a pesquisa."
            type="error"
          />,
          options
        );

        return;
      }

      if (
        data.searchKnowledgeFrom !== '' &&
        (!isValid(new Date(data.searchKnowledgeFrom)) ||
          format(new Date(data.searchKnowledgeFrom), 'yyyy')?.replace(/^0+/, '')
            ?.length < 4 ||
          !isBefore(new Date(data.searchKnowledgeFrom), new Date()))
      ) {
        toast(
          <Toast
            title="Atenção!"
            content="Para realizar a consulta é necessário informar um período válido."
            type="error"
          />,
          options
        );

        setSearchError('searchKnowledgeFrom', { message: 'Data inválida' });

        return;
      }

      if (
        data.searchKnowledgeFrom &&
        (!data.searchKnowledgeTo || data.searchKnowledgeTo === '')
      ) {
        toast(
          <Toast
            title="Atenção!"
            content="O campo “Data – Período a” deve ser preenchido para prosseguir com a pesquisa."
            type="error"
          />,
          options
        );

        return;
      }

      if (
        data.searchKnowledgeTo !== '' &&
        (!isValid(new Date(data.searchKnowledgeTo)) ||
          format(new Date(data.searchKnowledgeTo), 'yyyy')?.replace(/^0+/, '')
            ?.length < 4 ||
          isBefore(
            new Date(data.searchKnowledgeTo),
            new Date(data.searchKnowledgeFrom)
          ))
      ) {
        toast(
          <Toast
            title="Atenção!"
            content="Para realizar a consulta é necessário informar um período válido."
            type="error"
          />,
          options
        );

        setSearchError('searchKnowledgeTo', { message: 'Data inválida' });

        return;
      }

      if (data.searchKnowledgeFrom !== '' && data.searchKnowledgeTo !== '') {
        const interval = intervalToDuration({
          start: new Date(data.searchKnowledgeFrom),
          end: new Date(data.searchKnowledgeTo)
        });

        if (
          isBefore(data.searchKnowledgeTo, data.searchKnowledgeFrom) ||
          (interval.months > 0 && interval.days > 0) ||
          (interval.months === 0 && interval.days === 0) ||
          interval.months > 1
        ) {
          toast(
            <Toast
              title="Atenção!"
              content="Para realizar a consulta é necessário informar um período válido com intervalo máximo de 30 dias."
              type="error"
            />,
            options
          );

          setSearchError('searchKnowledgeTo', { message: 'Data inválida' });

          return;
        }
      }
    }

    const requestObject = {};

    requestObject.puser_document = user.document;

    requestObject.ppage = '0';

    requestObject.pitems = '10';

    if (data.knowledgeId) {
      requestObject.pctrc = data.knowledgeId;
    } else {
      if (data.searchKnowledgeFrom) {
        requestObject.pinitial_date = format(
          new Date(data.searchKnowledgeFrom),
          'dd-MM-yyyy'
        );
      }

      if (data.searchKnowledgeTo) {
        requestObject.pfinal_date = format(
          new Date(data.searchKnowledgeTo),
          'dd-MM-yyyy'
        );
      }

      if (data.knowledgeNumber) {
        requestObject.pawb = data.knowledgeNumber;
      }

      if (data.taxDocumentNumber) {
        requestObject.pinvoice = data.taxDocumentNumber;
      }

      if (data.ufFrom) {
        requestObject.psender_uf = data.ufFrom;
      }

      if (data.ufTo) {
        requestObject.preceiver_uf = data.ufTo;
      }

      if (data.searchModal) {
        requestObject.ptransport_type = data.searchModal === '1' ? 'R' : 'A';
      }

      if (data.searchCnpjSender) {
        requestObject.psender_document = parseCpfCnpj(data.searchCnpjSender);
      }

      if (data.searchCnpjRecipient) {
        requestObject.preceiver_document = parseCpfCnpj(
          data.searchCnpjRecipient
        );
      }
    }

    setSearchPage(0);
    setSearchRows([]);
    setLastSearchPayload(requestObject);
    setDisabledConfirmButton(true);

    try {
      const response = await searchKnowledge({
        params: requestObject
      });

      const { list: pickupList, pages } = response;
      setSearchTotalPages(Number(pages) + 1 || 1);

      if (pickupList.length > 0) {
        const list = [];
        const showInvoice = [];
        const senderDocumentList = [];

        pickupList.forEach((pickup) => {
          showInvoice.push(false);
          const {
            awb,
            ctrc,
            creation,
            invoice,
            transportType,
            senderDocument
          } = pickup;

          senderDocumentList.push({ senderDocument, awb });

          let day = getDate(parseISO(creation));
          let month = getMonth(parseISO(creation)) + 1;
          const year = getYear(parseISO(creation));

          if (day < 10) day = `0${day}`;
          if (month < 10) month = `0${month}`;

          const knowledgeData = `${day}/${month}/${year}`;

          let modal = '';

          if (transportType === 'R') {
            modal = 'Rodoviário';
          } else if (transportType === 'A') {
            modal = 'Rodoaéreo';
          }

          list.push({
            pickup,
            pickup_id: awb,
            knowledgeNumber: awb,
            knowledgeId: ctrc,
            creation,
            modal,
            knowledgeData,
            branch: '-',
            invoice
          });
        });

        // eslint-disable-next-line no-restricted-syntax
        for await (const senderDocument of senderDocumentList) {
          const senderDocuments = await searchUser({
            searchData: { document: senderDocument.senderDocument }
          });

          const searchBranch = { zip_Code: senderDocuments[0].zipPostalCode };

          const branchResponse = await getBranchDetails({
            params: searchBranch
          });

          const index = list.findIndex(
            (value) => value.pickup_id === senderDocument.awb
          );

          if (index >= 0 && branchResponse.length > 0) {
            list[index].branch = branchResponse[0].filial;
          }
        }

        setDocumentList(senderDocumentList);
        setSearchRows(list);
      } else {
        toast(
          <Toast
            title="Atenção!"
            content="Não foram localizados registros para esta pesquisa."
            type="error"
          />,
          options
        );

        setSearchRows([]);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);

      toast(
        <Toast
          title="Atenção!"
          content="Falha ao buscar conhecimento. Pesquise novamente ou tente mais tarde."
          type="error"
        />,
        options
      );
    }
  };

  const onChangePage = async (newPage) => {
    const newLastSearchPayload = { ...lastSearchPayload, ppage: newPage };

    setLastSearchPayload(newLastSearchPayload);
    setDisabledConfirmButton(true);
    // eslint-disable-next-line no-use-before-define
    setValue('knowledgeId', '');

    try {
      const response = await searchKnowledge({
        params: newLastSearchPayload
      });

      const { list: pickupList } = response;

      if (pickupList.length > 0) {
        const list = [];
        const showInvoice = [];
        const senderDocumentList = [];

        pickupList.forEach((pickup) => {
          showInvoice.push(false);
          const {
            awb,
            ctrc,
            creation,
            invoice,
            transportType,
            senderDocument
          } = pickup;

          senderDocumentList.push({ senderDocument, awb });

          let day = getDate(parseISO(creation));
          let month = getMonth(parseISO(creation)) + 1;
          const year = getYear(parseISO(creation));

          if (day < 10) day = `0${day}`;
          if (month < 10) month = `0${month}`;

          const knowledgeData = `${day}/${month}/${year}`;

          let modal = '';

          if (transportType === 'R') {
            modal = 'Rodoviário';
          } else if (transportType === 'A') {
            modal = 'Rodoaéreo';
          }

          list.push({
            pickup,
            pickup_id: awb,
            knowledgeNumber: awb,
            knowledgeId: ctrc,
            creation,
            modal,
            knowledgeData,
            branch: '-',
            invoice
          });
        });

        // eslint-disable-next-line no-restricted-syntax
        for await (const senderDocument of senderDocumentList) {
          const senderDocuments = await searchUser({
            searchData: { document: senderDocument.senderDocument }
          });

          const searchBranch = { zip_Code: senderDocuments[0].zipPostalCode };

          const branchResponse = await getBranchDetails({
            params: searchBranch
          });

          const index = list.findIndex(
            (value) => value.pickup_id === senderDocument.awb
          );

          if (index >= 0 && branchResponse.length > 0) {
            list[index].branch = branchResponse[0].filial;
          }
        }

        setDocumentList(senderDocumentList);
        setSearchRows(list);
      } else {
        setSearchRows([]);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);

      toast(
        <Toast
          title="Atenção!"
          content="Falha ao buscar conhecimento. Pesquise novamente ou tente mais tarde."
          type="error"
        />,
        options
      );
    }

    setIsSubmittingSearchPagination(false);
  };

  const knowledgeNumberSchema = Yup.object().shape({
    knowledgeId: Yup.string()
  });

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors, isSubmitting }
  } = useForm({
    resolver: yupResolver(knowledgeNumberSchema)
  });

  const onSubmit = async (data) => {
    const pickupSearched = searchRows.find(
      (row) => `${row.knowledgeId}` === `${data.knowledgeId}`
    );

    if (pickupSearched) {
      if (pickupSearched.knowledgeId === knowledgeId) {
        closeModal();
        return;
      }

      setKnowledgeNumber(pickupSearched.knowledgeNumber);
      setKnowledgeId(pickupSearched.knowledgeId);

      try {
        setHasCreatePickupWithInvoice(false);
        setDisabledSenderData(false);
        const { pickup } = pickupSearched;

        const senderResponse = await searchUser({
          searchData: { document: parseCpfCnpj(pickup.receiverDocument) }
        });

        if (senderResponse?.length > 0) {
          const userSenderSearched = senderResponse[0];

          if (userSenderSearched.document) {
            const pickupManagerResponse =
              await getPickupManagerParameterization({
                branchId: 1,
                transportTypeId: 9,
                pickupTypeId: 1,
                inputTypeId: 5
              });

            if (pickupManagerResponse?.length > 0) {
              const validationResponse =
                await getPickupManagerBranchValidations({
                  branchParameterizationId:
                    pickupManagerResponse[0]?.branchParameterizationId
                });

              if (validationResponse?.length > 0) {
                if (
                  validationResponse[0]?.validatePendingCharge ||
                  validationResponse[0]?.validateLegalPending
                ) {
                  const userHasRestriction = await verifyUserRestriction({
                    document: parseCpfCnpj(userSenderSearched?.document)
                  });

                  if (userHasRestriction?.isBlocked) {
                    const {
                      name,
                      document,
                      zipPostalCode,
                      streetAddress,
                      streetAddressNumber,
                      addressComplement,
                      suburb,
                      city,
                      state
                    } = userSenderSearched;

                    const address = {
                      zipPostalCode,
                      streetAddress,
                      streetAddressNumber,
                      additionalInformation: addressComplement || '',
                      suburb,
                      city,
                      state,
                      country: ''
                    };

                    const cancelResponse = await cancelReversePickup({
                      data: {
                        pickup: {
                          requesterCorporation: {
                            requesterType: 'sender',
                            document: parseCpfCnpj(document),
                            name,
                            address,
                            contactList: []
                          },
                          shipmentList: [
                            {
                              transportTypeId: null,
                              freightTypeId: null,
                              senderCorporation: null,
                              receiverCorporation: {
                                document: parseCpfCnpj(document),
                                name,
                                address,
                                contactList: []
                              },
                              shipmentAvailability: null,
                              shipmentPackageList: null,
                              taxInformation: null
                            }
                          ],
                          pickupCancelType: 'Restrição Financeira ou Jurídica'
                        }
                      }
                    });

                    if (cancelResponse.status === 200) {
                      setProtocolCollectCanceled(
                        cancelResponse.data.data.protocol
                      );
                    }

                    openModal('modalFinancialRestriction');

                    return;
                  }
                }
              }
            }

            const newAddressSenderList = [];

            newAddressSenderList.push({
              document: parseCpfCnpj(userSenderSearched.document),
              name: userSenderSearched.name,
              address: {
                zipPostalCode: userSenderSearched.zipPostalCode,
                streetAddress: userSenderSearched.streetAddress,
                streetAddressNumber: userSenderSearched.streetAddressNumber,
                additionalInformation: userSenderSearched.addressComplement,
                suburb: userSenderSearched.suburb,
                city: userSenderSearched.city,
                state: userSenderSearched.state
              }
            });

            setIsToValidateSenderDocument(false);

            const searchAddressResponse = await searchUser({
              searchData: { name: userSenderSearched.name }
            });

            if (searchAddressResponse?.length > 0) {
              searchAddressResponse
                ?.filter(
                  (value) =>
                    String(value.document) !==
                    String(userSenderSearched.document)
                )
                .forEach((value) => {
                  const {
                    document,
                    name,
                    streetAddress,
                    streetAddressNumber,
                    addressComplement,
                    suburb,
                    city,
                    state,
                    zipPostalCode
                  } = value;

                  const addressParsed = {
                    document,
                    name: name ? name.toUpperCase() : '',
                    address: {
                      zipPostalCode: zipPostalCode
                        ? parsePhone(zipPostalCode)
                        : '',
                      streetAddress: streetAddress
                        ? streetAddress.toUpperCase()
                        : '',
                      streetAddressNumber: streetAddressNumber ?? '',
                      additionalInformation: addressComplement
                        ? addressComplement.toUpperCase()
                        : '',
                      suburb: suburb ? suburb.toUpperCase() : '',
                      city: city ? city.toUpperCase() : '',
                      state: state ? state.toUpperCase() : ''
                    }
                  };

                  newAddressSenderList.push(addressParsed);
                });
            }

            setAddressSenderList(newAddressSenderList);

            setCollectSenderData(newAddressSenderList[0]);
          }
        } else {
          setAddressSenderList([]);
          setCollectSenderData({});
        }

        const recipientResponse = await searchUser({
          searchData: { document: parseCpfCnpj(pickup.senderDocument) }
        });

        if (recipientResponse?.length > 0) {
          const userRecipientSearched = recipientResponse[0];

          if (userRecipientSearched.document) {
            const {
              name,
              document,
              zipPostalCode,
              streetAddress,
              streetAddressNumber,
              addressComplement,
              suburb,
              city,
              state
            } = userRecipientSearched;

            const recipientData = {
              name,
              document,
              address: {
                zipPostalCode,
                streetAddress,
                streetAddressNumber,
                additionalInformation: addressComplement,
                suburb,
                city,
                state
              },
              contactList: []
            };

            setCollectRecipientData(recipientData);
          }
        } else {
          setCollectRecipientData(collectRequesterData);
        }

        if (pickupSearched?.modal === 'Rodoviário') {
          setCollectLoadData({ ...collectLoadData, modal: 1 });
        } else {
          setCollectLoadData({ ...collectLoadData, modal: 2 });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }

      setSelectedAddressSenderIndex(0);
    } else {
      setKnowledgeNumber('');
      setKnowledgeId('');
      setCollectSenderData({});
      setAddressSenderList([]);
      setCollectRecipientData(collectRequesterData);
    }

    closeModal();
  };

  const handleReset = () => {
    searchReset();
    setSearchValue('searchKnowledgeFrom', null);
    setSearchValue('searchKnowledgeTo', null);
    setSearchValue('knowledgeNumber', '');
    setSearchValue('knowledgeId', '');
    setSearchValue('taxDocumentNumber', '');
    setSearchValue('ufFrom', '');
    setSearchValue('ufTo', '');
    setSearchValue('searchModal', '');
    setSearchValue('searchCnpjSender', '');
    setSearchValue('searchNameSender', '');
    setSearchValue('searchCnpjRecipient', '');
    setSearchValue('searchNameRecipient', '');
    setDateSearchFrom(null);
    setDateSearchTo(null);
    setKnowledgeSearchNumber('');
    setKnowledgeSearchId('');
    setInvoiceSearchNumber('');
    setUfSearchFrom('');
    setUfSearchTo('');
    setModalSearch('');
    setDocumentSearchSender('');
    setDocumentSearchRecipient('');
    setSearchRows([]);
    setSearchPage(0);
    setValue('knowledgeNumber', '');
    setValue('knowledgeId', '');
    setKnowledgeNumber('');
    setKnowledgeId('');
    setCollectSenderData({});
    setAddressSenderList([]);
    setDisableSenderStreetAddress(true);
    setDisableSenderSuburb(true);
    setCollectRecipientData(collectRequesterData);
    setDisabledCleanButton(true);
    setDisabledConfirmButton(true);
  };

  const handleCloseModal = () => {
    closeModal();
  };

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    '&:last-child td, &:last-child th': {
      border: 0
    }
  }));

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }));

  const handleChangePage = (_, newPage) => {
    setIsSubmittingSearchPagination(true);
    setSearchPage(newPage);
    onChangePage(newPage);
  };

  const getDocumentInfo = async (value, entity) => {
    if (value) {
      try {
        const userSearched = await searchUser({
          searchData: { document: parseCpfCnpj(value) }
        });

        if (userSearched?.length > 0) {
          const { name } = userSearched[0];

          setSearchValue(`searchName${entity}`, name.toUpperCase());
        } else {
          toast(
            <Toast
              title="Atenção!"
              content="CNPJ/ CPF não cadastrado. Favor verificar."
              type="error"
            />,
            options
          );
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (
      (dateSearchFrom === '' || dateSearchFrom === null) &&
      (dateSearchTo === '' || dateSearchTo === null)
    ) {
      setSearchValue('ufFrom', '');
      setSearchValue('ufTo', '');
      setSearchValue('searchModal', '');
      setSearchValue('searchCnpjSender', '');
      setSearchValue('searchNameSender', '');
      setSearchValue('searchCnpjRecipient', '');
      setSearchValue('searchNameRecipient', '');
      clearSearchErrors([
        'ufFrom',
        'ufTo',
        'searchModal',
        'searchCnpjSender',
        'searchNameSender',
        'searchCnpjRecipient',
        'searchNameRecipient'
      ]);
    }
  }, [dateSearchFrom, dateSearchTo]);

  useEffect(() => {
    if (
      ((dateSearchFrom === '' || dateSearchFrom === null) &&
        (dateSearchTo === '' || dateSearchTo === null)) ||
      knowledgeSearchNumber !== '' ||
      knowledgeSearchId !== ''
    ) {
      setSearchValue('searchModal', '');
      clearSearchErrors(['searchModal']);
    }
  }, [knowledgeSearchNumber, knowledgeSearchId]);

  useEffect(() => {
    const cpfCnpjOptions = {
      onKeyPress(cpf, _ev, _el, op) {
        const masks = ['000.000.000-000', '00.000.000/0000-00'];
        $('#documentSearchSender').mask(
          cpf.length > 14 ? masks[1] : masks[0],
          op
        );
      }
    };

    $('#documentSearchSender').length > 11
      ? $('#documentSearchSender').mask('00.000.000/0000-00', cpfCnpjOptions)
      : $('#documentSearchSender').mask('000.000.000-00#', cpfCnpjOptions);
  }, [documentSearchSender]);

  useEffect(() => {
    const cpfCnpjOptions = {
      onKeyPress(cpf, _ev, _el, op) {
        const masks = ['000.000.000-000', '00.000.000/0000-00'];
        $('#documentSearchRecipient').mask(
          cpf.length > 14 ? masks[1] : masks[0],
          op
        );
      }
    };

    $('#documentSearchRecipient').length > 11
      ? $('#documentSearchRecipient').mask('00.000.000/0000-00', cpfCnpjOptions)
      : $('#documentSearchRecipient').mask('000.000.000-00#', cpfCnpjOptions);
  }, [documentSearchRecipient]);

  useEffect(() => {
    let enableClearButton = false;

    if (dateSearchFrom) {
      setSearchValue('searchKnowledgeFrom', dateSearchFrom);
      enableClearButton = true;
    }

    if (dateSearchTo) {
      setSearchValue('searchKnowledgeTo', dateSearchTo);
      enableClearButton = true;
    }

    if (knowledgeSearchNumber) {
      setSearchValue('knowledgeNumber', knowledgeSearchNumber);
      enableClearButton = true;
    }

    if (knowledgeSearchId) {
      setSearchValue('knowledgeId', knowledgeSearchId);
      enableClearButton = true;
    }

    if (invoiceSearchNumber) {
      setSearchValue('taxDocumentNumber', invoiceSearchNumber);
      enableClearButton = true;
    }

    if (ufSearchFrom) {
      setSearchValue('ufFrom', ufSearchFrom);
      enableClearButton = true;
    }

    if (ufSearchTo) {
      setSearchValue('ufTo', ufSearchTo);
      enableClearButton = true;
    }

    if (modalSearch) {
      setSearchValue('searchModal', modalSearch);
      enableClearButton = true;
    }

    if (documentSearchSender) {
      setSearchValue('searchCnpjSender', documentSearchSender);
      getDocumentInfo(documentSearchSender, 'Sender');
      enableClearButton = true;
    }

    if (documentSearchRecipient) {
      setSearchValue('searchCnpjRecipient', documentSearchRecipient);
      getDocumentInfo(documentSearchRecipient, 'Recipient');
      enableClearButton = true;
    }

    if (enableClearButton) {
      setDisabledCleanButton(false);
    }
  }, []);

  return (
    <Modal preventClose>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '86vh',
          overflow: 'auto'
        }}
      >
        <form
          onSubmit={handleSearchSubmit(onSearchSubmit)}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 16
          }}
        >
          <ModalTitle>Pesquisar - Conhecimento</ModalTitle>

          <Stack
            direction={maxMD ? 'column' : 'row'}
            spacing={2}
            style={{ width: '100%' }}
          >
            <Stack direction={maxMD ? 'row' : 'column'} spacing={2}>
              <Controller
                name="searchKnowledgeFrom"
                defaultValue=""
                control={searchControl}
                render={({ field }) => (
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={ptBRLocale}
                  >
                    <DatePicker
                      label="Período de"
                      mask="__/__/____"
                      {...field}
                      value={(field.value = dateSearchFrom)}
                      onChange={(value) => {
                        setDateSearchFrom(value);
                        field.onChange(value);
                        setDisabledCleanButton(false);
                      }}
                      disabled={!!isSubmittingSearch || !!isSubmitting}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          onBlur={(event) => {
                            if (
                              event?.target?.value?.length >= 8 &&
                              event?.target?.value?.length < 10
                            ) {
                              const [day, month, year] =
                                event.target.value.split('/');

                              const newDate = new Date(
                                `20${year?.replace(/^0+/, '')}`,
                                month - 1,
                                day
                              );

                              setDateSearchFrom(newDate);
                              setValue('searchKnowledgeFrom', newDate);
                            }
                          }}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: 'DD/MM/AAAA'
                          }}
                          error={!!searchErrors.searchKnowledgeFrom}
                          helperText={searchErrors.searchKnowledgeFrom?.message}
                          style={{ width: maxMD ? '100%' : 192 }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                )}
              />

              <Controller
                name="searchKnowledgeTo"
                defaultValue=""
                control={searchControl}
                render={({ field }) => (
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={ptBRLocale}
                  >
                    <DatePicker
                      label="A"
                      mask="__/__/____"
                      {...field}
                      value={(field.value = dateSearchTo)}
                      onChange={(value) => {
                        setDateSearchTo(value);
                        field.onChange(value);
                        setDisabledCleanButton(false);
                      }}
                      disabled={!!isSubmittingSearch || !!isSubmitting}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          onBlur={(event) => {
                            if (
                              event?.target?.value?.length >= 8 &&
                              event?.target?.value?.length < 10
                            ) {
                              const [day, month, year] =
                                event.target.value.split('/');

                              const newDate = new Date(
                                `20${year?.replace(/^0+/, '')}`,
                                month - 1,
                                day
                              );

                              setDateSearchTo(newDate);
                              setValue('searchKnowledgeTo', newDate);
                            }
                          }}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: 'DD/MM/AAAA'
                          }}
                          error={!!searchErrors.searchKnowledgeTo}
                          helperText={searchErrors.searchKnowledgeTo?.message}
                          style={{ width: maxMD ? '100%' : 192 }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                )}
              />
            </Stack>

            <Stack spacing={2} style={{ width: '100%' }}>
              <Controller
                name="knowledgeNumber"
                defaultValue=""
                control={searchControl}
                render={({ field }) => (
                  <TextField
                    label="Número Conhecimento"
                    {...field}
                    disabled={!!isSubmittingSearch || !!isSubmitting}
                    value={(field.value = knowledgeSearchNumber)}
                    onChange={(e) => {
                      const regex = /^[0-9]+$/;
                      if (
                        !e.target.value.match(regex) &&
                        e.target.value !== ''
                      ) {
                        return;
                      }

                      setKnowledgeSearchNumber(e.target.value);
                      setDisabledCleanButton(false);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      setKnowledgeSearchNumber(e.target.value);
                      field.onBlur(field.onChange(e.target.value));
                    }}
                    error={!!searchErrors.knowledgeNumber}
                    helperText={searchErrors.knowledgeNumber?.message}
                  />
                )}
              />

              <Controller
                name="knowledgeId"
                defaultValue=""
                control={searchControl}
                render={({ field }) => (
                  <TextField
                    label="ID Conhecimento"
                    {...field}
                    disabled={!!isSubmittingSearch || !!isSubmitting}
                    value={(field.value = knowledgeSearchId)}
                    onChange={(e) => {
                      const regex = /^[0-9]+$/;
                      if (
                        !e.target.value.match(regex) &&
                        e.target.value !== ''
                      ) {
                        return;
                      }

                      setKnowledgeSearchId(e.target.value);
                      setDisabledCleanButton(false);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      setKnowledgeSearchId(e.target.value);
                      field.onBlur(field.onChange(e.target.value));
                    }}
                    error={!!searchErrors.knowledgeId}
                    helperText={searchErrors.knowledgeId?.message}
                  />
                )}
              />

              <Controller
                name="taxDocumentNumber"
                defaultValue=""
                control={searchControl}
                render={({ field }) => (
                  <TextField
                    label="Número da NF"
                    {...field}
                    disabled={!!isSubmittingSearch || !!isSubmitting}
                    value={(field.value = invoiceSearchNumber)}
                    onChange={(e) => {
                      const regex = /^[0-9]+$/;
                      if (
                        !e.target.value.match(regex) &&
                        e.target.value !== ''
                      ) {
                        return;
                      }

                      setInvoiceSearchNumber(e.target.value);
                      setDisabledCleanButton(false);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      setInvoiceSearchNumber(e.target.value);
                      field.onBlur(field.onChange(e.target.value));
                    }}
                    error={!!searchErrors.taxDocumentNumber}
                    helperText={searchErrors.taxDocumentNumber?.message}
                  />
                )}
              />
            </Stack>

            <Stack
              direction={maxSM ? 'column' : maxMD ? 'row' : 'column'}
              spacing={2}
              style={{ marginRight: !maxMD && 126 }}
            >
              <Controller
                name="ufFrom"
                defaultValue=""
                control={searchControl}
                render={({ field }) => (
                  <FormControl
                    disabled={
                      ((dateSearchFrom === '' || dateSearchFrom === null) &&
                        (dateSearchTo === '' || dateSearchTo === null)) ||
                      !!isSubmittingSearch ||
                      !!isSubmitting
                    }
                    error={!!searchErrors.ufFrom}
                    style={{ width: '100%', minWidth: 152 }}
                  >
                    <InputLabel>UF Origem</InputLabel>
                    <Select
                      id="ufFrom"
                      label="UF Origem"
                      {...field}
                      value={(field.value = ufSearchFrom)}
                      onChange={(e) => {
                        setUfSearchFrom(e.target.value);
                        setDisabledCleanButton(false);
                        field.onChange(e.target.value);
                      }}
                      error={!!searchErrors.ufFrom}
                    >
                      <MenuItem value="" style={{ height: 36 }} />
                      {statesList.map(({ uf }) => (
                        <MenuItem key={uf} value={uf}>
                          {uf}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              />

              <Controller
                name="ufTo"
                defaultValue=""
                control={searchControl}
                render={({ field }) => (
                  <FormControl
                    disabled={
                      ((dateSearchFrom === '' || dateSearchFrom === null) &&
                        (dateSearchTo === '' || dateSearchTo === null)) ||
                      !!isSubmittingSearch ||
                      !!isSubmitting
                    }
                    error={!!searchErrors.ufTo}
                    style={{ width: '100%', minWidth: 152 }}
                  >
                    <InputLabel>UF Destino</InputLabel>
                    <Select
                      id="ufTo"
                      label="UF Destino"
                      {...field}
                      value={(field.value = ufSearchTo)}
                      onChange={(e) => {
                        setUfSearchTo(e.target.value);
                        setDisabledCleanButton(false);
                        field.onChange(e.target.value);
                      }}
                      error={!!searchErrors.ufTo}
                    >
                      <MenuItem value="" style={{ height: 36 }} />
                      {statesList.map(({ uf }) => (
                        <MenuItem key={uf} value={uf}>
                          {uf}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              />

              <Controller
                name="searchModal"
                defaultValue=""
                control={searchControl}
                render={({ field }) => (
                  <FormControl
                    disabled={
                      ((dateSearchFrom === '' || dateSearchFrom === null) &&
                        (dateSearchTo === '' || dateSearchTo === null)) ||
                      knowledgeSearchNumber !== '' ||
                      knowledgeSearchId !== '' ||
                      !!isSubmittingSearch ||
                      !!isSubmitting
                    }
                    error={!!searchErrors.searchModal}
                    style={{ width: '100%', minWidth: 152 }}
                  >
                    <InputLabel>Modal</InputLabel>
                    <Select
                      id="searchModal"
                      label="Modal"
                      {...field}
                      value={(field.value = modalSearch)}
                      onChange={(e) => {
                        setModalSearch(e.target.value);
                        setDisabledCleanButton(false);
                        field.onChange(e.target.value);
                      }}
                      error={!!searchErrors.searchModal}
                    >
                      <MenuItem value="" style={{ height: 36 }} />
                      {transportTypeList.map(
                        ({ description, transport_Type_Id }) => (
                          <MenuItem
                            key={transport_Type_Id}
                            value={transport_Type_Id}
                          >
                            {description}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </FormControl>
                )}
              />
            </Stack>
          </Stack>

          <Stack spacing={2} style={{ width: '100%', marginBottom: 16 }}>
            <Stack direction={maxSM ? 'column' : 'row'} spacing={2}>
              <Controller
                name="searchCnpjSender"
                defaultValue=""
                control={searchControl}
                render={({ field }) => (
                  <TextField
                    label="CNPJ/CPF Remetente"
                    id="documentSearchSender"
                    {...field}
                    fullWidth
                    disabled={
                      ((dateSearchFrom === '' || dateSearchFrom === null) &&
                        (dateSearchTo === '' || dateSearchTo === null)) ||
                      !!isSubmittingSearch ||
                      !!isSubmitting
                    }
                    value={(field.value = documentSearchSender)}
                    onChange={(e) => {
                      setSearchValue('searchNameSender', '');
                      setDocumentSearchSender(e.target.value);
                      setDisabledCleanButton(false);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      const { value } = e.target;
                      getDocumentInfo(value, 'Sender');
                      setDocumentSearchSender(e.target.value);
                      field.onBlur(field.onChange(value));
                    }}
                    error={!!searchErrors.searchCnpjSender}
                    helperText={searchErrors.searchCnpjSender?.message}
                  />
                )}
              />

              <Controller
                name="searchNameSender"
                defaultValue=""
                control={searchControl}
                render={({ field }) => (
                  <TextField
                    label="Razão Social/Nome Remetente"
                    {...field}
                    disabled
                    fullWidth
                    error={!!searchErrors.searchNameSender}
                    helperText={searchErrors.searchNameSender?.message}
                  />
                )}
              />

              {!maxSM && (
                <LoadingButton
                  type="submit"
                  variant="contained"
                  style={{ minWidth: 110, height: 56 }}
                  loading={!!isSubmittingSearch}
                  disabled={!!isSubmittingSearch || !!isSubmitting}
                >
                  Pesquisar
                </LoadingButton>
              )}
            </Stack>

            <Stack
              direction={maxSM ? 'column' : 'row'}
              spacing={2}
              style={{ width: maxSM && '100%', alignItems: maxSM && 'center' }}
            >
              <Controller
                name="searchCnpjRecipient"
                defaultValue=""
                control={searchControl}
                render={({ field }) => (
                  <TextField
                    label="CNPJ/CPF Destinatário"
                    id="documentSearchRecipient"
                    {...field}
                    fullWidth={maxSM}
                    disabled={
                      ((dateSearchFrom === '' || dateSearchFrom === null) &&
                        (dateSearchTo === '' || dateSearchTo === null)) ||
                      !!isSubmittingSearch ||
                      !!isSubmitting
                    }
                    value={(field.value = documentSearchRecipient)}
                    onChange={(e) => {
                      setSearchValue('searchNameRecipient', '');
                      setDocumentSearchRecipient(e.target.value);
                      field.onChange(e.target.value);
                      setDisabledCleanButton(false);
                    }}
                    onBlur={(e) => {
                      const { value } = e.target;
                      getDocumentInfo(value, 'Recipient');
                      setDocumentSearchRecipient(e.target.value);
                      field.onBlur(field.onChange(value));
                    }}
                    style={{ minWidth: 320 }}
                    error={!!searchErrors.searchCnpjRecipient}
                    helperText={searchErrors.searchCnpjRecipient?.message}
                  />
                )}
              />

              <Controller
                name="searchNameRecipient"
                defaultValue=""
                control={searchControl}
                render={({ field }) => (
                  <TextField
                    label="Razão Social/Nome Destinatário"
                    {...field}
                    disabled
                    fullWidth={maxSM}
                    style={{ minWidth: 320 }}
                    error={!!searchErrors.searchNameRecipient}
                    helperText={searchErrors.searchNameRecipient?.message}
                  />
                )}
              />

              <Stack direction="row" spacing={2}>
                <Button
                  type="button"
                  variant="contained"
                  style={{ minWidth: 110, height: !maxSM && 56 }}
                  onClick={handleReset}
                  disabled={
                    !!isSubmittingSearch ||
                    !!isSubmitting ||
                    disabledCleanButton
                  }
                >
                  Limpar
                </Button>

                {maxSM && (
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    style={{ minWidth: 110, height: !maxSM && 56 }}
                    loading={!!isSubmittingSearch}
                    disabled={!!isSubmittingSearch || !!isSubmitting}
                  >
                    Pesquisar
                  </LoadingButton>
                )}
              </Stack>
            </Stack>
          </Stack>
        </form>

        <form
          onSubmit={handleSubmit(onSubmit)}
          style={{ width: '100%', paddingTop: 16, borderTop: '1px solid #888' }}
        >
          <TableContainer component={Paper} style={{ maxWidth: '96vw' }}>
            <Controller
              control={control}
              defaultValue=""
              name="knowledgeId"
              render={({ field }) => {
                return (
                  <RadioGroup {...field}>
                    <Table stickyHeader size="small">
                      <TableHead>
                        <StyledTableRow>
                          <StyledTableCell>Selecionar</StyledTableCell>
                          <StyledTableCell>
                            Número Conhecimento/AWB
                          </StyledTableCell>
                          <StyledTableCell>Modal</StyledTableCell>
                          <StyledTableCell>
                            Data do Conhecimento
                          </StyledTableCell>
                          <StyledTableCell>Filial</StyledTableCell>
                          <StyledTableCell align="center">NF</StyledTableCell>
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>
                        {searchRows.length === 0 ? (
                          <StyledTableRow>
                            <StyledTableCell
                              colSpan={6}
                              style={{ textAlign: 'center', color: '#888' }}
                            >
                              {isSubmittingSearch
                                ? 'Pesquisando...'
                                : 'Sem resultados'}
                            </StyledTableCell>
                          </StyledTableRow>
                        ) : (
                          <>
                            {searchRows
                              ?.sort((a, b) => {
                                if (
                                  new Date(a.creation) < new Date(b.creation)
                                ) {
                                  return -1;
                                }
                                if (
                                  new Date(a.creation) > new Date(b.creation)
                                ) {
                                  return 1;
                                }
                                return 0;
                              })
                              ?.map((row) => {
                                return (
                                  <StyledTableRow
                                    key={row.knowledgeId}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    <StyledTableCell>
                                      <Radio
                                        name="knowledgeId"
                                        id={row.knowledgeId}
                                        value={row.knowledgeId}
                                        onClick={() => {
                                          if (
                                            !isSubmitting &&
                                            !isSubmittingSearchPagination
                                          ) {
                                            setValue(
                                              'knowledgeId',
                                              row.knowledgeId
                                            );
                                            setDisabledConfirmButton(false);
                                          }
                                        }}
                                        disabled={
                                          !!isSubmitting ||
                                          !!isSubmittingSearchPagination
                                        }
                                      />
                                    </StyledTableCell>
                                    <StyledTableCell>
                                      {row.knowledgeNumber}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                      {row.modal}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                      {row.knowledgeData}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                      {row.branch}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                      <Button
                                        type="button"
                                        disabled={
                                          !!isSubmitting ||
                                          !!isSubmittingSearchPagination
                                        }
                                        onClick={(e) => {
                                          e.stopPropagation();

                                          setSelectedKnowledgeIdToShowInvoices(
                                            row.knowledgeId
                                          );
                                          setSelectedKnowledgeNumberToShowInvoices(
                                            row.knowledgeNumber
                                          );
                                          openShowInvoiceSearchListModal();
                                        }}
                                      >
                                        <IoMdEye size={20} />
                                      </Button>
                                    </StyledTableCell>
                                  </StyledTableRow>
                                );
                              })}
                          </>
                        )}
                      </TableBody>
                      {searchRows.length > 0 && (
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              count={searchRows.length * searchTotalPages || 1}
                              page={searchPage}
                              labelDisplayedRows={() => {
                                // eslint-disable-next-line prettier/prettier
                                return `Página ${
                                  searchPage + 1
                                } de ${searchTotalPages}`;
                              }}
                              onPageChange={(event, newPage) => {
                                !isSubmittingSearchPagination &&
                                  handleChangePage(event, newPage);
                              }}
                              rowsPerPage={10}
                              rowsPerPageOptions={[10]}
                              showFirstButton={searchTotalPages > 2}
                              showLastButton={searchTotalPages > 2}
                            />
                          </TableRow>
                        </TableFooter>
                      )}
                    </Table>
                  </RadioGroup>
                );
              }}
            />
          </TableContainer>

          <FormHelperText error={!!errors.knowledgeNumber}>
            {errors.knowledgeNumber?.message}
          </FormHelperText>

          <Stack
            direction="row"
            spacing={2}
            style={{
              width: '100%',
              marginTop: 16,
              justifyContent: 'center'
            }}
          >
            <Button
              type="button"
              variant="contained"
              color="secondary"
              onClick={handleCloseModal}
              disabled={!!isSubmitting}
            >
              Cancelar
            </Button>

            <LoadingButton
              type="submit"
              variant="contained"
              loading={!!isSubmitting}
              disabled={disabledConfirmButton}
            >
              Confirmar
            </LoadingButton>
          </Stack>
        </form>
      </Box>
    </Modal>
  );
};
